import * as React from 'react'
import { Button, CircularProgress } from '@mui/material'
import CreditIcon from '@mui/icons-material/CreditCardOutlined'
import { useSnackbarComponent } from '../../SnackbarComponents/useSnackbarComponent'
import { createFlutterwaveCheckoutSession } from '../../../services/api-requests/flutterwave-request'

interface PayWithFlutterwaveProps {
  text?: string
  metadata: FlutterwaveMetadataInterface
  currency: string
  email: string
  amount: number
  success_url: string
  callback: Function
  close: Function
  disabled?: boolean
  logo: string
  payment_plan?: string // for subscription to flutterwave plan
  buttonStyle?: React.CSSProperties
  course_tier?: number
}

export interface FlutterwaveMetadataInterface {
  user_name: string
  user_id: string
  school_id: string
  additional_info?: string
  email: string
  phone_number?: string
  payment_for: string
  course_id?: string
  payments_alert_id?: string
  payment_plan_invoice_id?: string
  coupon_code?: string
  subscription_type?: 'basic' | 'pro'
  no_of_students?: number
  gift?: any
  course_tier?: number
}

const PayWithFlutterwave = (props: PayWithFlutterwaveProps) => {
  const [loading, setLoading] = React.useState(false)

  const snackbarHook = useSnackbarComponent()

  const payWithFlutterwave = async () => {
    try {
      setLoading(true)
      const axiosRes = await createFlutterwaveCheckoutSession({
        currency: props.currency,
        title: '',
        email: props.email,
        successUrl: props.success_url,
        amount: props.amount,
        metadata: props.metadata,
        userName: props.metadata.user_name,
        phoneNumber: props.metadata.phone_number,
        description: `Payment for ${props.metadata.payment_for
          ?.trim()
          .replace(/^\w/, (c: any) => c.toUpperCase())}`,
        logo: props.logo,
        payment_plan: props.payment_plan,
      })
      console.log('fluttterwave', { axiosRes })
      if (!axiosRes?.data?.data) {
        throw new Error('Unable to get flutterwave payment details')
      }
      const url = axiosRes?.data?.data?.data?.data?.link
      console.log('checkout url', url)
      window.open(url, '_self')
      props.close()
    } catch (err) {
      snackbarHook.open(
        'Error getting payment information. Please try again',
        'error',
      )
    }
    setLoading(false)
  }

  return (
    <>
      <Button
        style={{ height: '55px', ...props.buttonStyle }}
        size="large"
        color="primary"
        variant="contained"
        onClick={payWithFlutterwave}
        disabled={props.disabled || loading}
        disableElevation={true}
        fullWidth={true}
      >
        <CreditIcon style={{ marginRight: '5px' }} />
        {props.text || 'Make Payment'}
        {loading && <CircularProgress size={20} />}
      </Button>
    </>
  )
}

export default PayWithFlutterwave
